// extracted by mini-css-extract-plugin
export default {"teste":"styles_teste__c1E+j","catLogoDiv":"styles_catLogoDiv__p9HZ7","logoDiv":"styles_logoDiv__MqiiA","buttonDiv":"styles_buttonDiv__bVZop"};